import styled from 'styled-components'
import { Pill } from '@components/Pill'

/** Styles for the admin itinerary-imports list. */

/** Gives the status filter a stable width so the toolbar doesn't jump as the label changes. */
export const StatusFilterWrap = styled.div`
	min-width: 200px;
`

export const StatusPill = styled(Pill).attrs({ $size: 'sm' as const })``
